import { Layers } from '@modules/core';
import { useZed } from '@modules/core/src/react/useZed';
import { useEffect, useState } from 'react';
import { Toaster } from 'sonner';

import { TourDanjiModule } from '../TourDanjiModule';

import { useScreen } from './hooks/useScreen';

const TOAST_OFFSET_DEFAULT = '96px';
const TOAST_OFFSET_DESKTOP_INTERIOR = '220px';
const TOAST_OFFSET_MOBILE_INTERIOR = '200px';

export function ToastContainer() {
  const zed = useZed<[TourDanjiModule]>();
  const [isInterior, setIsInterior] = useState(false);
  const { isDesktop } = useScreen();

  useEffect(() => {
    if (!zed) return;

    const checkInterior = (type: string | undefined) => {
      setIsInterior(type === 'UnitWindowView' || type === 'FakeUnitWindowView');
    };

    // Initialize state
    checkInterior(zed.api.getCameraType());

    const observer = zed.api.observer.onCameraViewTypeChanged.add((type) => {
      checkInterior(type);
    });
    return () => {
      observer?.remove();
    };
  }, [zed]);

  return (
    <Toaster
      position="bottom-center"
      duration={3000}
      visibleToasts={1}
      style={{ zIndex: Layers.UI_CONTENTS + 1, '--width': 'min(calc(100vw - 24px), 600px)', pointerEvents: 'none' } as React.CSSProperties}
      toastOptions={{
        style: {
          background: 'rgba(26, 26, 26, 0.8)',
          color: '#ffffff',
          borderRadius: '12px',
          backdropFilter: 'blur(4px)',
          WebkitBackdropFilter: 'blur(4px)',
          border: 'none',
          fontFamily: "'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          fontSize: '14px',
          fontWeight: '400',
          padding: '12px 16px',
          boxShadow: 'none',
          pointerEvents: 'auto',
        },
      }}
      offset={isInterior ? (isDesktop ? TOAST_OFFSET_DESKTOP_INTERIOR : TOAST_OFFSET_MOBILE_INTERIOR) : TOAST_OFFSET_DEFAULT}
    />
  );
}
